class SiteElementCustomFieldsPreview
    extends QueryElement<HTMLElement> {

    private _defaultText: string;
    private _customFields: SiteElementCustomFields;

    constructor(element: HTMLElement, customFields: SiteElementCustomFields) {
        super(element);

        this._defaultText = this.getHtml() ?? "";
        this._customFields = customFields;

        customFields.on("input", () => {
            this.changed();
        })
    }

    private changed()
    {
        var values = this._customFields.values();
        this.setAttr("class", "custom-fields-preview");
        
        if (values["Font"] != "")
        {
            this.addClass(`font-${values["Font"]}`);
        }
        if (values["Description"] != "")
        {
            this.setHtml(this.nl2br(values["Description"]));
        }
        else
        {
            this.setHtml(this._defaultText);
        }
    }

    private nl2br(input: string) {
        return input.replace(/(\r\n|\r|\n)/g, '<br>');
    }
}